import axiosHttpClient from "../axiosHttpClient";

export function post(data: any) {
	return axiosHttpClient.post('/consistency-class', data);
}

export function getAll() {
	return axiosHttpClient.get('/consistency-classes');
}

export function getOne(id: number) {
	return axiosHttpClient.get('/consistency-class/one/'+id.toString());
}

export function deleteAllowed(id: number) {
	return axiosHttpClient.get('/consistency-class/delete-allowed/'+id.toString());
}

export function remove(id: number) {
	return axiosHttpClient.get('/consistency-class/delete/'+id.toString());
}

